import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import findFolder from 'owa-service/lib/findFolder';
import type FolderId from 'owa-service/lib/contract/FolderId';
import getRequestOptions from './getRequestOptions';

const cache: { [targetMailbox: string]: FolderId } = {};

export default async function getOutlookSpacesApplicationFolderId(targetMailbox: string) {
    if (!(targetMailbox in cache)) {
        const applicationFolderId = await findFolder(
            distinguishedFolderId({ Id: 'root' }),
            'IPM.ApplicationData',
            '7aadb841-2368-4d24-a373-94d0ba1f077a',
            getRequestOptions(targetMailbox)
        );

        if (applicationFolderId) {
            cache[targetMailbox] = applicationFolderId.FolderId;
        }
    }

    return cache[targetMailbox];
}
